import { useState } from "react";
import { InitialResolver } from "@/lib/use.middlewares";
import { RedProjects } from "@/lib/path-resolver-middlewares/redProjects";
import ProjectsScreen from "@/containers/project-screen/projectsScreen";
import AppLayout from "@/containers/layouts/AppLayout";
import RedFilters from "@/components/filters/red/filters";
import { usePath } from "@/contexts/path/path";
import ProjectScreen from "@/containers/project-screen/ProjectScreen";
import ProjectUnitView from "@/containers/project-screen/ProjectUnitView";
import RealestateDeveloperPage from "@/containers/project-screen/developer-screen/DeveloperScreen";

function RealestateProjectsPage(props) {
  const [frozenContext, setFrozenContext] = useState();
  const { unit, project, developer } = usePath();
  if (unit) return <ProjectUnitView frozenContext={frozenContext} />;
  if (project) return <ProjectScreen setFrozenContext={setFrozenContext} />;
  if (developer) return <RealestateDeveloperPage />;
  return <ProjectsScreen projectsRes={props?.projectsRes} />;
}

export default RealestateProjectsPage;
RealestateProjectsPage.getLayout = ({ children, ...props }) => {
  return (
    <AppLayout {...props}>
      <RedFilters.Layout>{children}</RedFilters.Layout>
    </AppLayout>
  );
};

RealestateProjectsPage.getInitialProps = InitialResolver(
  RedProjects.ResolveFilters,
  RedProjects.ResolveProjects,
  RedProjects.ResolveDeveloper,
  RedProjects.ResolveProject,
  RedProjects.ResolveProjectUnit,
);
